import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import BarcodeScanner from './components/barcodeScanner';
import utils from '../../utils/utils';

const PackerDeliveryOrderItem = ({ item, itemName, onItemCheck, isPacked, quantity, tempEnums, refundButtons }) => {
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [notMatchingGtin, setNotMatchingGtin] = useState(null);

  const temperature = item.temperature ? tempEnums.find((value) => value.name === item.temperature) : null;

  const onSuccess = () => {
    setNotMatchingGtin(null);
    setShowBarcodeModal(false);
    onItemCheck();
  };

  const onItemClick = () => {
    if (item.packingRequiresBarcode && item.gtin) {
      setNotMatchingGtin(null);
      setShowBarcodeModal(true);
    } else {
      onSuccess();
    }
  };

  const { formatMessage } = useIntl();

  return (
    <li className={`text-large m-b-1 ${isPacked ? 'text-muted' : ''}`}>
      <span onClick={onItemClick} className={`m-r-2 ${isPacked ? 'text-strikethrough' : ''}`}>
        {quantity > 1 ? <strong className="text-danger">{quantity} x </strong> : ''}{' '}
        {itemName || utils.getItemName(item, formatMessage)} {temperature ? temperature.icon : ''}{' '}
      </span>
      {refundButtons ? (
        <>
          {refundButtons} <br />
        </>
      ) : (
        ''
      )}
      {item.shouldDoWeightRefunds ? (
        <span className="alert alert-primary text-small">
          <FormattedMessage id={'packer.delivery.order.batch.row.order.item.weight.refund.notice'} />
        </span>
      ) : (
        ''
      )}

      <Modal show={showBarcodeModal} onHide={() => setShowBarcodeModal(false)} size="lg">
        <div onClick={() => setShowBarcodeModal(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal barcode-modal">
          {showBarcodeModal ? (
            <>
              <BarcodeScanner
                onSuccess={(gtin) => {
                  if (gtin === item.gtin) {
                    onSuccess();
                  } else {
                    setNotMatchingGtin(gtin);
                  }
                }}
              />
              {notMatchingGtin ? (
                <div className="alert alert-warning m-b-3">
                  <FormattedMessage
                    id={'packer.delivery.order.batch.row.order.item.not.matching.gtin'}
                    values={{ gtin: `${notMatchingGtin}`, itemGtin: item.gtin }}
                  />
                </div>
              ) : (
                ''
              )}
              <div className="m-b-6">
                <div className="text-center">
                  <button onClick={onSuccess} className="btn btn-primary btn-small">
                    <FormattedMessage id={'packer.delivery.order.batch.row.order.item.cancel.scan'} />
                  </button>
                </div>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </Modal>
    </li>
  );
};

PackerDeliveryOrderItem.propTypes = {};

PackerDeliveryOrderItem.defaultProps = {};

export default PackerDeliveryOrderItem;
